module.exports = __webpack_public_path__ + "img/interactive-top.1d444391.png";